import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue"
import { useStorage } from "@vueuse/core"

export default /*@__PURE__*/_defineComponent({
  __name: 'videoHeight',
  setup(__props) {

const userInfo = useStorage("userinfo", {})
const appointment = useStorage("appointment", {})

// 上课期间-视频窗口开启关闭-控制界面内单词列表顶部是否增高
const videoHeight = useStorage("videoHeight", true, sessionStorage)

// 获取视频高度
const videoOrientation = useStorage("videoOrientation", {}, sessionStorage)

// 计算属性：视频高度
const practicalVideoHeight = computed(() => {
  return videoOrientation.value.height === "9rem" ? "7rem" : "3rem"
})

return (_ctx: any,_cache: any) => {
  return (!_unref(userInfo).isAdmin)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "video-height",
        style: _normalizeStyle({
      height: _unref(videoHeight) && _unref(appointment).videoFlag === 1 ? practicalVideoHeight.value : '0px',
    })
      }, null, 4))
    : _createCommentVNode("", true)
}
}

})